import Vue from 'vue/dist/vue.min.js';
import EventBus from './event-bus';
import store from './store';
import {pardotFormInstance} from "./pardot-form";

const Drawer = () => {
    const drawers = document.querySelectorAll('.drawer__wrapper');
    
    let drawerConstructor = (id) => {
        // main component wrapper
        Vue.component('drawer-template', {
            data: function() {
                return {
                    activeTab: '',
                    isMobile: store.state.isMobile,
                    store: store
                }
            },
            computed: {
                mobileState: function() {
                    return store.state.isMobile;
                }
            },
            watch: {
                mobileState: function() {
                    this.isMobile = this.mobileState;
                }
            },
            methods: {
                setActiveTab(e) {
                    this.activeTab = e;
                },
                handleTab(e) {
                    let tabTarget = e.currentTarget.dataset.target;
                    
                    if (tabTarget !== this.activeTab) {
                        // console.log("derp");
                        this.setActiveTab(tabTarget);
                        this.$el.querySelector('.drawer__tab-item.active').classList.remove('active');
    
                        this.$el.querySelector(`[data-target=${tabTarget}]`).classList.add('active');
                    }
                },
                setResponsive() {

                    if (!isMobile) {
                        // remove inline styles from accordions
                        let accordionContainers = this.$el.querySelectorAll('.drawer__drawer-content-container');
                        accordionContainers.forEach((item) => {
                            item.style = null;
                        });
                    }
                },
                // set the first tab to active
                initDesktop() {

                    if (this.isMobile) { //under 768px
                    } else { //over 768px
                        // if desktop, check for desktop buttons and set initial tab
                        let initial = this.$el.querySelector('[data-target]').dataset.target;
                        this.activeTab = initial;
                        this.$el.querySelector('[data-target]').classList.add('active');
                    }
                }
            },
            mounted() {
                // console.log(store.state.isMobile);
                this.initDesktop(); //set the first tab to active on init
                //listen for child click events on the labels and pass targets to parent
                EventBus.$on('handle-mobile', (e) => {
                    this.setActiveTab(e);
                })
                EventBus.$on('handle-desktop', (e) => {
                    this.setActiveTab(e);
                })
            }
        });

        // desktop labels
        Vue.component('drawer-tab-label', {
            props: ['activeTab', 'isMobile'],
            data: function() {
                return {
                    tabTarget: '',
                    isActive: false
                }
            },
            watch: {
                activeTab: function() {
                    this.isActive = this.activeTab == this.tabTarget ? true : false;
                }
            },
            methods: {
                handleTab(e) {
                    EventBus.$emit('handle-desktop', this.tabTarget);
                }
            },
            mounted() {
                this.tabTarget = this.$el.dataset.target;
            }
        });

        // mobile accordion containers & labels
        Vue.component('drawer-content-template', {
            props: ['activeTab', 'isMobile'], //active tab 
            data: function() {
                return {
                    tabName: '',
                    isActive: false, //is current tab the selected tab 'activeTab'
                    isOpen: false, //is tab open
                }
            },
            watch: {
                activeTab: function(tab) {
                    this.isActive = this.tabName == tab ? true : false;
                },
                isActive: function() {
                    if (!this.isActive) {
                        this.isOpen = false; //set accodion to close when not the active item

                        // close the accordion
                        if (this.isMobile) {

                        let contentArea = this.$el.querySelector('.drawer__drawer-content-container');
                        let contentHeight = this.$el.querySelector('.drawer__drawer-content-inner').getBoundingClientRect().height;

                        requestAnimationFrame(function() {
                            //set content area height to content height to prevent transitioning from auto
                            contentArea.style.maxHeight = contentHeight + 'px';
                            // have the element transition to height: 0
                            requestAnimationFrame(function() {
                                contentArea.style.maxHeight = '0px';
                            });
                        });

                        contentArea.addEventListener('transitionend', () => {
                            contentArea.style.maxHeight = '0';
                        });

                        this.scrollToTop();
                        }
                    } else {
                        // if this is the active tab, set isOpen to true when isActive is true to pre open the tab on mobile
                        this.isOpen = true;
                    }
                }
            },
            methods: {
                handleMobile(e) {
                    let mobileTarget = e.currentTarget.parentNode.dataset.tabId;

                    EventBus.$emit('handle-mobile', mobileTarget);

                    if (this.isMobile) {
                        // toggle the accordion
                        this.handleAccordion(e);
                    }
                },
                // toggle accordions
                handleAccordion(e) {
                    let contentArea = this.$el.querySelector('.drawer__drawer-content-container');
                    let contentHeight = this.$el.querySelector('.drawer__drawer-content-inner').getBoundingClientRect().height;

                    if (this.isOpen == true) {
                        this.isOpen = false;

                        requestAnimationFrame(function() {
                            //set content area height to content height to prevent transitioning from auto
                            contentArea.style.maxHeight = contentHeight + 'px';
                            // have the element transition to height: 0
                            requestAnimationFrame(function() {
                                contentArea.style.maxHeight = '0px';
                            });
                        });

                        contentArea.addEventListener('transitionend', () => {
                            contentArea.style.maxHeight = '0';
                        });

                    } else {
                        this.isOpen = true;
                        contentArea.style.maxHeight = contentHeight + "px";
                        contentArea.addEventListener('transitionend', () => {
                            contentArea.style.maxHeight = 'none';
                        });
                    }
                },
                scrollToTop() {
                    let elmOffset = this.$el.offsetTop;
                    let scrollOffset = window.scrollY;
                    // console.log("el",elmOffset);
                    // console.log("window",scrollOffset);
                    if (elmOffset < scrollOffset) {
                        let elmPos = this.$el.getBoundingClientRect().top + window.scrollY;
                        setTimeout(function() {
                            window.scrollTo({
                                top: (elmPos - 70),
                                behavior: 'smooth'
                            });
                        },500);
                    }
                },

                initMobile() {
                    if (this.isMobile) {
                        // console.log("is mobile");
                    } else {
                        // console.log("not mobile");

                        // remove all inline styles for accordions on desktop
                        let contentContainers = this.$el.querySelectorAll('.drawer__drawer-content-container');
                        contentContainers.forEach((item) => {
                            item.style = ''
                        });
                    }   
                }
            },
            mounted() {
                var initialTab = this.$el.dataset.tabId;
                this.tabName = initialTab;
                this.initMobile();
            }
        });

        // import pardot form component instance
        pardotFormInstance;

        new Vue({
            el: `.drawer-${id}`,
            store: store
        }).$mount(`.drawer-${id}`, true);
    }

    if (drawers.length > 0) {
        drawers.forEach((item, index) => {
            item.classList.add(`drawer-${index}`);
            drawerConstructor(index);
        })
    }
}

export default Drawer;